import { render, staticRenderFns } from "./CBadge.vue?vue&type=template&id=6174a0ad&scoped=true"
import script from "./CBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CBadge.vue?vue&type=style&index=0&id=6174a0ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6174a0ad",
  null
  
)

export default component.exports